import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { keycloakAuthInterceptor } from './core/interceptors/keycloak-auth.interceptor';
import { sessionInterceptor } from './core/interceptors/session.interceptor';
import { KeycloakAuthService } from './core/services/keycloak-auth.service';

function initializeAuth(authService: KeycloakAuthService) {
  return () => authService.init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor, keycloakAuthInterceptor, sessionInterceptor])
    ),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [KeycloakAuthService],
      multi: true
    }
  ],
};
